import GoodsTracking from "@/pages/ys/GoodsTracking"
import GoodsTrackingMap from "@/pages/ys/GoodsTrackingMap"
import Index from "@/pages/ys/Index"
import Search from "@/pages/ys/Search"
import Th from "@/pages/ys/th/Index"
import ThOrder from "@/pages/ys/th/Order"
import ThGoods from "@/pages/ys/th/Goods"
import ThTrans from "@/pages/ys/th/Trans"
import ThFiles from "@/pages/ys/th/Files"
import Sh from "@/pages/ys/sh/Index"
import ShOrder from "@/pages/ys/sh/Order"
import ShGoods from "@/pages/ys/sh/Goods"
import ShTrans from "@/pages/ys/sh/Trans"
import ShFiles from "@/pages/ys/sh/Files"
import Thd from "@/pages/ys/Thd"
import Psd from "@/pages/ys/Psd"
import Abnormal from "@/pages/ys/Abnormal"

let router = [{
    path: "/ys/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/ys/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/ys/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  }, {
    path: "/ys/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  }, {
    path: "/ys/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  }, {
    path: "/ys/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  }, {
    path: "/ys/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [{
      path: "/ys/th/order",
      name: "order",
      component: ThOrder,
      meta: {
        title: "提货单信息"
      },
    }, {
      path: "/ys/th/goods",
      name: "goods",
      component: ThGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/ys/th/trans",
      name: "trans",
      component: ThTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/ys/th/files",
      name: "files",
      component: ThFiles,
      meta: {
        title: "回单"
      },
    }]
  }, {
    path: "/ys/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [{
      path: "/ys/sh/order",
      name: "order",
      component: ShOrder,
      meta: {
        title: "送货单信息"
      },
    }, {
      path: "/ys/sh/goods",
      name: "goods",
      component: ShGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/ys/sh/trans",
      name: "trans",
      component: ShTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/ys/sh/files",
      name: "files",
      component: ShFiles,
      meta: {
        title: "回单"
      },
    }]
  },
  {
    path: "/ys/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  },{
    path: "/ys/transfer",
    name: "transfer",
    component: () => import('@/pages/ys/Transfer'),
    meta: {
      title: "中转",
      keepAlive: false,
      login: false
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/ys.js